// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input_cell{display:flex;-moz-column-gap:.375rem;column-gap:.375rem}.error--text{color:red}.v-text-field.error--text fieldset{border-color:red}", ""]);
// Exports
module.exports = exports;
